<template>

  <div id="container">

    <input id="upload-overlay"
           :class="uploadOverlayActive ? 'active' : 'inactive'"
           type="file"
           accept="image/*"
           @dragover.prevent="toggleDragOverlay"
           @dragend.prevent="removeDragOverlay"
           @dragexit.prevent="removeDragOverlay"
           @dragleave.prevent="removeDragOverlay"
           @drop.prevent="setImageWithDrop"
           @click.prevent="''"/>
    <div id="drag-overlay" v-if="dragOverlayToggled">
      <p id="drag-overlay-txt">Drop file here</p>
    </div>

    <div id="upload" v-if="!imgSrc">
      <div id="upload-content">
        <p id="upload-txt">Drag/drop your file here</p>
        <p id="upload-sub-txt">or</p>
        <div id="upload-button-container">
          <div id="upload-button-content">
            <input id="upload-button"
                   type="file"
                   accept="image/*"
                   @change="setImageWithButton"/>
            <div id="upload-button-txt-container">
              <p id="upload-button-txt">Add file</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="crop" v-if="imgSrc">
      <div v-show="!logoValidated">
        <p id="cropper-title">Crop image</p>
        <div class="cropper-container">
          <vue-cropper
            ref="cropper"
            :aspect-ratio="aspectRatio"
            :src="imgSrc"
            preview=".preview"
            :min-container-height="90"/>
        </div>
        <p class="instructions-txt">You can zoom in/out</p>
      </div>
      <p id="preview-title" v-show="!logoValidated">Preview</p>
      <div id="preview-container">
        <div class="preview-border" v-show="!logoValidated">
          <div class="preview" :aspect-ratio="1"></div>
        </div>
        <img class="preview-validated" v-show="logoValidated" alt="Logo validé" :src="cropImg"/>
        <div class="validate-logo-button" v-if="!logoValidated" @click="validateLogo">
          <p class="validate-logo-button-txt">Validate</p>
        </div>
        <div class="change-logo-button" v-if="logoValidated" @click="deleteLogo">
          <p class="change-logo-button-txt">Change logo</p>
        </div>
      </div>
    </div>

    <p class="instructions-txt" v-if="!imgSrc">Add a jpg or png image</p>

  </div>

</template>

<script>

import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'LogoUploader',
  props: {
    editedImage: {
      type: Object,
      default: null
    },
    aspectRatio: {
      type: Number
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    VueCropper
  },
  data (vm) {
    return {
      imgSrc: null,
      cropImg: '',
      fileName: '',
      uploadOverlayActive: false,
      dragOverlayToggled: false,
      logoValidated: false,
      cropperOptions: {
        width: 600,
        height: 600,
        fillColor: 'white',
        mimeType: 'image/jpeg',
        ...vm.options
      }
    }
  },
  mounted () {
    if (this.editedImage) {
      this.setEditedImageData()
    } else {
      this.resetLogoData()
      window.addEventListener('dragenter', () => {
        this.activateUploadOverlay()
      })
    }
  },
  methods: {
    activateUploadOverlay () {
      if (!this.uploadOverlayActive) {
        this.uploadOverlayActive = true
      }
    },
    toggleDragOverlay () {
      this.dragOverlayToggled = true
    },
    removeDragOverlay () {
      this.dragOverlayToggled = false
      this.uploadOverlayActive = false
    },
    setImageWithDrop (e) {
      this.removeDragOverlay()
      if (e.dataTransfer.items) {
        for (let i = 0; i < e.dataTransfer.items.length; i++) {
          // If dropped items aren't files, reject them
          if (e.dataTransfer.items[i].kind === 'file' && (e.dataTransfer.items[i].type === 'image/png' || e.dataTransfer.items[i].type === 'image/jpeg')) {
            let file = e.dataTransfer.items[i].getAsFile()
            if (typeof FileReader === 'function') {
              const reader = new FileReader()
              reader.onload = (event) => {
                this.fileName = this.normalize(file.name)
                this.imgSrc = event.target.result
                // rebuild cropperjs with the updated source
                // this.$refs.cropper.replace(event.target.result)
              }
              reader.readAsDataURL(file)
              window.removeEventListener('dragenter', () => {
                this.activateUploadOverlay()
              })
            }
          } else {
            alert('Please select a jpg or png image')
          }
        }
      }
    },
    setImageWithButton (e) {
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        alert('Please select a jpg or png image')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.fileName = this.normalize(file.name)
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          // this.$refs.cropper.replace(event.target.result)
        }
        reader.readAsDataURL(file)
        window.removeEventListener('dragenter', () => {
          this.activateUploadOverlay()
        })
      } else {
        alert('Error setting image file')
      }
    },
    setEditedImageData () {
      this.imgSrc = this.editedImage.logoURL
      this.cropImg = this.editedImage.logoURL
      this.fileName = this.editedImage.logoFileName
      this.logoValidated = true
    },
    validateLogo () {
      this.logoValidated = true
      this.cropImg = this.$refs.cropper.getCroppedCanvas(this.cropperOptions).toDataURL(this.cropperOptions.mimeType).replace(this.cropperOptions.mimeType, 'application/octet-stream')
      this.fileName = this.fileName.replace(/\.[^/.]+$/, `.${this.cropperOptions.mimeType.replace('image/', '')}`)
      this.$emit('logoValidated', this.cropImg, this.fileName)
    },
    deleteLogo () {
      this.$emit('logoDeleted')
      this.resetLogoData()
    },
    resetLogoData () {
      this.imgSrc = null
      this.cropImg = null
      this.fileName = ''
      this.uploadOverlayActive = false
      this.logoValidated = false
      window.addEventListener('dragenter', () => {
        this.activateUploadOverlay()
      })
    },
    normalize (string) {
      return string.replace(/([^a-z0-9 .]+)/gi, '-')
    }
  },
  watch: {
    'editedImage' () {
      if (this.editedImage) {
        this.setEditedImageData()
      } else {
        this.resetLogoData()
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('dragenter', () => {
      this.activateUploadOverlay()
    })
  }
}

</script>

<style lang="scss" scoped>

  img {
    display: block;
    max-width: 100%;
  }

  p {
    margin-bottom: 0;
  }

  #container {
    margin-bottom: 20px;
  }

  #upload-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: 0;
    z-index: 3;
    &.inactive {
      pointer-events: none;
    }
    &.active {
      pointer-events: auto;
    }
  }

  #drag-overlay {
    position: fixed;
    background-color: #000033;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: 0.6;
    z-index: 2;
    display: grid;
  }

  #drag-overlay-txt {
    text-align: center;
    align-self: center;
    color: white;
    font-size: 30px;
    font-weight: 700;
  }

  #upload {
    border: 2px dashed #cccccc;
    padding: 60px 0;
    display: grid;
  }

  #upload-content {
    align-self: center;
  }

  #upload-txt {
    color: #000033;
    text-align: center;
  }

  #upload-sub-txt {
    color: #000033;
    text-align: center;
    font-weight: 700;
    margin-bottom: 4px;
  }

  #upload-button-container {
    display: grid;
    position: relative;
  }

  #upload-button-content {
    justify-self: center;
    background-color: #e8e8e8;
    height: 32px;
    width: 132px;
    border-radius: 2px;
    overflow: hidden;
    -webkit-transition: background-color .25s;
    -moz-transition: background-color .25s;
    -o-transition: background-color .25s;
    -ms-transition: background-color .25s;
    transition: background-color .25s;
    transition-timing-function: ease;
    &:hover {
      background-color: #cccccc;
    }
  }

  #upload-button {
    position: absolute;
    opacity: 0;
    height: 32px;
    width: 132px;
    z-index: 2;
    cursor: pointer;
  }

  #upload-button-txt-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 32px;

    display: grid;
  }

  #upload-button-txt {
    text-align: center;
    align-self: center;
    color: #000033;
    font-size: 12px;
  }

  .instructions-txt {
    color: #888888;
    font-size: 12px;
    margin-top: 4px;
  }

  #cropper-title {
    font-weight: 700;
    font-size: 12px;
    color: #000099;
    margin-bottom: 12px;
  }

  .cropper-container {
    width: 200px;
  }

  #preview-title {
    font-size: 12px;
    color: #000033;
    margin-bottom: 6px;
  }

  #preview-container {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 12px;
  }

  .preview-border {
    border: 2px solid #000033;
    min-width: 42px;
    min-height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .preview {
    width: 42px;
    height: 42px;
    overflow: hidden;
  }

  .preview-validated {
    align-self: center;
    width: 60px;
    border: 2px solid #000033;
  }

  .preview-infos-container {
    align-self: center;
  }

  .preview-file-name {
    color: #cccccc;
    font-size: 12px;
    margin-bottom: 4px;
  }

  .preview-logo-validated-container {
    width: fit-content;
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 6px;
  }

  .preview-logo-validated-txt {
    color: #000099;
    font-size: 12px;
    font-weight: 700;
    width: fit-content;
  }

  .preview-logo-validated-img {
    width: 14px;
    height: 14px;
    align-self: center;
  }

  .change-logo-button {
    cursor: pointer;
    align-self: center;
    width: fit-content;
    height: fit-content;
    padding: 6px 18px;
    border: 2px solid #000033;
    border-radius: 2px;
    background-color: white;
    display: grid;
    -webkit-transition: background-color .25s;
    -moz-transition: background-color .25s;
    -o-transition: background-color .25s;
    -ms-transition: background-color .25s;
    transition: background-color .25s;
    transition-timing-function: ease;
    &:hover {
      background-color: #e8e8e8;
    }
  }

  .change-logo-button-txt {
    margin: 0;
    text-align: center;
    align-self: center;
    color: #000033;
    font-size: 12px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .validate-logo-button {
    cursor: pointer;
    border-radius: 2px;
    background-color: #000099;
    max-width: 180px;
    display: grid;
    -webkit-transition: background-color .25s;
    -moz-transition: background-color .25s;
    -o-transition: background-color .25s;
    -ms-transition: background-color .25s;
    transition: background-color .25s;
    transition-timing-function: ease;
    &:hover {
      background-color: #0c0ca8;
    }
  }

  .validate-logo-button-txt {
    margin: 0;
    text-align: center;
    align-self: center;
    font-size: 12px;
    color: white;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .preview-logo-validated-delete-button {
    padding: 8px 10px;
    cursor: pointer;
    background-color: #cccccc;
    border-radius: 2px;
    width: fit-content;
    -webkit-transition: background-color .25s;
    -moz-transition: background-color .25s;
    -o-transition: background-color .25s;
    -ms-transition: background-color .25s;
    transition: background-color .25s;
    transition-timing-function: ease;
    &:hover {
      background-color: #afafaf;
    }
  }

  .preview-logo-validated-delete-button-txt {
    font-size: 12px;
    color: white;
    text-align: center;
  }

  #button {
    background-color: #000099;
    padding: 10px 24px;
    width: fit-content;
    cursor: pointer;
    display: grid;
  }

  #button-txt {
    color: white;
    font-size: 12px;
    align-self: center;
    justify-self: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/LogoUploader.vue